import { BaseDTO } from '../global/base.dto';

export class CaseDTO extends BaseDTO {

}
